import { render, staticRenderFns } from "./EDILogs.vue?vue&type=template&id=441d3dfe&scoped=true&"
import script from "./EDILogs.vue?vue&type=script&lang=js&"
export * from "./EDILogs.vue?vue&type=script&lang=js&"
import style0 from "./EDILogs.vue?vue&type=style&index=0&id=441d3dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441d3dfe",
  null
  
)

export default component.exports